module.exports = __webpack_public_path__ + "assets/images/extra_lady1.e61c2a8a66f9a4edc26ff61daf511e4a.svg";